<template>
    <svg aria-hidden="true" focusable="false" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22" cy="22" r="22" fill="white" />
        <path d="M18.8495 15.1935L13 13V27.8065L18.8495 30L25.3387 27.8065L31.0968 30V15.1935L25.3387 13L18.8495 15.1935Z" stroke="black" stroke-linejoin="round" />
        <line x1="18.9091" y1="15.1935" x2="18.9091" y2="30" stroke="black" />
        <line x1="25.2454" y1="13" x2="25.2454" y2="27.8065" stroke="black" />
    </svg>
</template>
